import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Lottie from 'react-lottie-player';
import { useSelector } from 'react-redux';

import successAnimation from 'src/public/animations/success.json';

import { getUserInformation } from 'src/modules/user/selectors/userSelectors';
import { color, font } from 'src/shared/styles/variables';

const Wrapper = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 70,
    paddingBottom: 100,
});

const SuccessAnimation = styled(Lottie)({
    width: 150,
    height: 150,
});

const HeaderText = styled.h4(
    {
        color: color.white,
        marginTop: 25,
        marginBottom: 20,
        textAlign: 'center',
        lineHeight: '44px',
    },
    font.black(font.size.extraLarge),
);

const DescriptionText = styled.h4(
    {
        color: color.white,
        textAlign: 'center',
        maxWidth: 350,
        lineHeight: '30px',
    },
    font.light(font.size.mediumExtended),
);

interface Props {
    providerFirstName: string;
    shouldShowScheduling: boolean;
    isPamm?: boolean;
}

export const RateSessionThankYouStep: React.FC<Props> = ({
    providerFirstName,
    shouldShowScheduling,
    isPamm,
}) => {
    const { t } = useTranslation();
    const { firstName } = useSelector(getUserInformation);

    const description = `videoSessions:rate_session.thank_you.${
        shouldShowScheduling ? 'description' : 'no_scheduling_description'
    }`;

    return (
        <Wrapper>
            <SuccessAnimation animationData={successAnimation} loop={false} speed={0.6} play />
            <HeaderText>
                {t('videoSessions:rate_session.thank_you.title', { name: firstName })}
            </HeaderText>
            {!isPamm && (
                <DescriptionText>{t(description, { name: providerFirstName })}</DescriptionText>
            )}
        </Wrapper>
    );
};
